let controller1 = new ScrollMagic.Controller();

// secton1
var box1_title=document.getElementsByClassName('box1_title');
var box1_subtitle=document.getElementsByClassName('box1_subtitle');


let scene1 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: ".xlimsq_section1",
        triggerHook: 0,
        duration: 1 
});

// secton2 
var box2_title=document.getElementsByClassName('box2_title');
var box2_subtitle=document.getElementsByClassName('box2_subtitle');
var box2_features=document.getElementsByClassName('box2_features');
let scene2 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.xlimsq_section2',
        triggerHook: "onenter",
        duration: 0
    });
// scene2.setPin(".xlimsq_section2");
    scene2.on("progress", function (event) {
        box2_title[0].classList.add("showup");
        box2_title[1].classList.add("showup");
        box2_subtitle[0].classList.add("showup");
        box2_subtitle[1].classList.add("showup");
        // box2_features[0].classList.add("showup");
        var index1=event.progress.toFixed(3) * 100;
        //console.log(index1);
        if(index1<2){
          box2_title[0].classList.remove("showup");
          box2_title[1].classList.remove("showup");
          box2_subtitle[0].classList.remove("showup");
          box2_subtitle[1].classList.remove("showup");
          // box2_features[0].classList.remove("showup");
          box2_features[0].classList.remove("showup");
        }
        if(index1>10){
          box2_features[0].classList.add("showup");
        }
      
        
    });

//section3
var box3_title=document.getElementsByClassName('sec3_title');
let scene3 = new ScrollMagic.Scene({
        //距离指定的元素什么位置开始执行
        offset: 0,
        // 告诉ScrollMagic当前的场景从哪一个元素开始
        // triggerElement: "footer",
        // triggerElement: ".section3",
        triggerElement: ".originse_section3",
        // 告诉ScrollMagic当前的场景从指定元素相对于视口的什么位置开始
        // triggerHook: "onEnter",
        // triggerHook: "onCenter",
        //设置触发元素进入或者离开视口开始触发事件
        triggerHook: "onenter",
        // 挂靠该元素时，会在该元素外部再加一个div，这个duration就是这个div的上下padding
        duration: 0, 
  reverse: true
    });
 // scene3.setPin(".xlimsq_section2");
    scene3.on("progress", function (event) {
        box3_title[0].classList.add("showup");
        // box2_features[0].classList.add("showup");
        var index=event.progress.toFixed(3) * 100;
        // console.log(index);
        if(index<2){
        box3_title[0].classList.remove("showup");
        }
        
    });

//section4
var box4_title=document.getElementsByClassName('box4_title');
var box4_subtitle=document.getElementsByClassName('box4_subtitle');
let scene4 = new ScrollMagic.Scene({
        //距离指定的元素什么位置开始执行
        offset: 0,
        // 告诉ScrollMagic当前的场景从哪一个元素开始
        // triggerElement: "footer",
        // triggerElement: ".section3",
        triggerElement: ".xlimsq_section4",
        // 告诉ScrollMagic当前的场景从指定元素相对于视口的什么位置开始
        // triggerHook: "onEnter",
        // triggerHook: "onCenter",
        //设置触发元素进入或者离开视口开始触发事件
        triggerHook: "onenter",
        // 挂靠该元素时，会在该元素外部再加一个div，这个duration就是这个div的上下padding
        duration: 0, 
  reverse: true
    });
 // scene4.setPin(".xlimsq_section2");
    scene4.on("progress", function (event) {
        box4_title[0].classList.add("showup");
        box4_title[1].classList.add("showup");
        box4_subtitle[0].classList.add("showup");
        // box2_features[0].classList.add("showup");
        var index=event.progress.toFixed(3) * 100;
        // console.log(index);
        if(index<2){
        box4_title[0].classList.remove("showup");
        box4_title[1].classList.remove("showup");
        box4_subtitle[0].classList.remove("showup");
          // box2_features[0].classList.remove("showup");
        }
        
    });

//section5
var box5_info=document.getElementsByClassName('box5_info');
let scene5 = new ScrollMagic.Scene({
        //距离指定的元素什么位置开始执行
        offset: 0,
        // 告诉ScrollMagic当前的场景从哪一个元素开始
        // triggerElement: "footer",
        // triggerElement: ".section3",
        triggerElement: ".xlimsq_section5",
        // 告诉ScrollMagic当前的场景从指定元素相对于视口的什么位置开始
        // triggerHook: "onEnter",
        // triggerHook: "onCenter",
        //设置触发元素进入或者离开视口开始触发事件
        triggerHook: "onenter",
        // 挂靠该元素时，会在该元素外部再加一个div，这个duration就是这个div的上下padding
        duration: 0, 
  reverse: true
    });

 // scene5.setPin(".xlimsq_section5");
    scene5.on("progress", function (event) {
        box5_info[0].classList.add("showup");
        // box2_features[0].classList.add("showup");
        var index=event.progress.toFixed(3) * 100;
        // console.log(index);
        if(index<2){
        box5_info[0].classList.remove("showup");
        }
        
    });

//section6
var box6_title=document.getElementsByClassName('box6_title');
var box6_infobox1=document.getElementsByClassName('box6_infobox1');
var box6_infobox2=document.getElementsByClassName('box6_infobox2');
let scene6 = new ScrollMagic.Scene({
        //距离指定的元素什么位置开始执行
        offset: -60,
        // 告诉ScrollMagic当前的场景从哪一个元素开始
        // triggerElement: "footer",
        // triggerElement: ".section3",
        triggerElement: ".xlimsq_section6",
        // 告诉ScrollMagic当前的场景从指定元素相对于视口的什么位置开始
        // triggerHook: "onEnter",
        // triggerHook: "onCenter",
        //设置触发元素进入或者离开视口开始触发事件
        triggerHook: "0",
        // 挂靠该元素时，会在该元素外部再加一个div，这个duration就是这个div的上下padding
        duration: 600, 
  reverse: true
    });
scene6.setPin(".xlimsq_section6");
    scene6.on("progress", function (event) {
        box6_title[0].classList.add("showup");
        // box2_features[0].classList.add("showup");
        var index=event.progress.toFixed(3) * 100;;
        //console.log(index);
        if(index<2){
        box6_title[0].classList.remove("showup");
        }
        
    });

let scene6_1 = new ScrollMagic.Scene({
        //距离指定的元素什么位置开始执行
        offset: 200,
        // 告诉ScrollMagic当前的场景从哪一个元素开始
        // triggerElement: "footer",
        // triggerElement: ".section3",
        triggerElement: ".xlimsq_section6",
        // 告诉ScrollMagic当前的场景从指定元素相对于视口的什么位置开始
        // triggerHook: "onEnter",
        // triggerHook: "onCenter",
        //设置触发元素进入或者离开视口开始触发事件
        triggerHook: "0",
        // 挂靠该元素时，会在该元素外部再加一个div，这个duration就是这个div的上下padding
        duration: 0, 
  reverse: true
    });
// scene6_1.setPin(".xlimsq_section6");
    scene6_1.on("progress", function (event) {
        box6_infobox1[0].classList.add("showup");
        // box2_features[0].classList.add("showup");
        var index=event.progress.toFixed(3) * 100;;
        //console.log(index);
        if(index<2){
        box6_infobox1[0].classList.remove("showup");
        }
        
    });

let scene6_2 = new ScrollMagic.Scene({
        //距离指定的元素什么位置开始执行
        offset: 400,
        // 告诉ScrollMagic当前的场景从哪一个元素开始
        // triggerElement: "footer",
        // triggerElement: ".section3",
        triggerElement: ".xlimsq_section6",
        // 告诉ScrollMagic当前的场景从指定元素相对于视口的什么位置开始
        // triggerHook: "onEnter",
        // triggerHook: "onCenter",
        //设置触发元素进入或者离开视口开始触发事件
        triggerHook: "0",
        // 挂靠该元素时，会在该元素外部再加一个div，这个duration就是这个div的上下padding
        duration: 0, 
  reverse: true
    });
// scene6_2.setPin(".xlimsq_section6");
    scene6_2.on("progress", function (event) {
        box6_infobox2[0].classList.add("showup");
        // box2_features[0].classList.add("showup");
        var index=event.progress.toFixed(3) * 100;;
        //console.log(index);
        if(index<2){
        box6_infobox2[0].classList.remove("showup");
        }
        
    });
//section7
var box7_title=document.getElementsByClassName('box7_title');
var box7_subtitle=document.getElementsByClassName('box7_subtitle');
let scene7 = new ScrollMagic.Scene({
        //距离指定的元素什么位置开始执行
        offset: 0,
        // 告诉ScrollMagic当前的场景从哪一个元素开始
        // triggerElement: "footer",
        // triggerElement: ".section3",
        triggerElement: ".xlimsq_section7",
        // 告诉ScrollMagic当前的场景从指定元素相对于视口的什么位置开始
        // triggerHook: "onEnter",
        // triggerHook: "onCenter",
        //设置触发元素进入或者离开视口开始触发事件
        triggerHook: "onenter",
        // 挂靠该元素时，会在该元素外部再加一个div，这个duration就是这个div的上下padding
        duration: 0, 
  reverse: true
    });
 // scene7.setPin(".xlimsq_section5");
    scene7.on("progress", function (event) {
        box7_title[0].classList.add("showup");
        box7_subtitle[0].classList.add("showup");        
        // box2_features[0].classList.add("showup");
        var index=event.progress.toFixed(3) * 100;
        // console.log(index);
        if(index<2){
        box7_title[0].classList.remove("showup");
        box7_subtitle[0].classList.remove("showup");  
        }
        
    });
//section9
var box9_feature_box=document.getElementsByClassName('box9_feature_box');
let scene9 = new ScrollMagic.Scene({
        //距离指定的元素什么位置开始执行
        offset: 40,
        // 告诉ScrollMagic当前的场景从哪一个元素开始
        // triggerElement: "footer",
        // triggerElement: ".section3",
        triggerElement: ".xlimsq_section9",
        // 告诉ScrollMagic当前的场景从指定元素相对于视口的什么位置开始
        // triggerHook: "onEnter",
        // triggerHook: "onCenter",
        //设置触发元素进入或者离开视口开始触发事件
        triggerHook: "onenter",
        // 挂靠该元素时，会在该元素外部再加一个div，这个duration就是这个div的上下padding
        duration: 0, 
  reverse: true
    });
 // scene9.setPin(".xlimsq_section5");
    scene9.on("progress", function (event) {
        box9_feature_box[0].classList.add("showup");
        box9_feature_box[1].classList.add("showup");
        box9_feature_box[2].classList.add("showup");
        box9_feature_box[3].classList.add("showup");      
        // box2_features[0].classList.add("showup");
        var index=event.progress.toFixed(3) * 100;
        // console.log(index);
        if(index<2){
        box9_feature_box[0].classList.remove("showup");
        box9_feature_box[1].classList.remove("showup");
        box9_feature_box[2].classList.remove("showup");
        box9_feature_box[3].classList.remove("showup");  
        }
        
    });

controller1.addScene([(scene1),scene2,scene3,scene4,scene5,scene6,scene6_1,scene6_2,scene7,scene9]); 

//header

$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-xlim-sq-kit');
})

$('.pnr_cart').click(function(){
    var element = document.querySelector(".xlimsq_section7");
    element.scrollIntoView({block: "end"});
})
$('.pnr_spec').click(function(){
    var element = document.querySelector(".xlimsq_section10");
    element.scrollIntoView({block: "end"});
})

//section3
var xlimsq3swiper = new Swiper('.xlimsq3swiper', {
	pagination: {
    el: '.swiper-pagination',
    clickable :true,
  },
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'my-button-disabled',
    },
})

var Mxlimsq3swiper = new Swiper('.Mxlimsq3swiper', {
	pagination: {
    el: '.swiper-pagination',
    clickable :true,
  }
})

//section11
new Glide('.glide',{
    gap: 0
}).mount();